export default __webpack_public_path__ + "static/media/BannerLandscapeTransparent.707dd1dc.png";